const AccentIds = {
  'highlight.straight': 'highlight--straight',
};

type AccentType = keyof typeof AccentIds;

interface AccentProps {
  [name: string]: any;
}

const BaseAccent = ({ variant, ...rest }: { variant: AccentType }) => (
  <svg {...rest} aria-hidden="true">
    <use href={`/images/accents.svg#${AccentIds[variant]}`} />
  </svg>
);
interface HighlightProps extends AccentProps {
  variant: 'straight';
}

export const Highlight = ({ variant, ...rest }: HighlightProps) => (
  <BaseAccent variant={`highlight.${variant}` as const} {...rest} />
);
